// * Price formatting
export const numberWithDots = x => {
  if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  return '';
};

export const getRandom = (max, min = 0) => Math.floor(Math.random() * max + min)

export const capitalizeSentence = (str) => {
  const lower = str.toLowerCase().replace(/\s+/g, ' ');
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};
